export default "__VITE_ASSET__BrEaaEGr__"